import '@fontsource-variable/bricolage-grotesque'
import '@fontsource-variable/manrope'
import '@fontsource-variable/geist-mono'
import './index.css'

import { startVersionWatch } from '@polf/shared/app-version'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import App from './App'
import ErrorBoundary from './ErrorBoundary'

// Tabs left open across a deploy move onto the new build at a moment where
// reloading costs nothing. The projector kiosk has nobody to disturb, so it
// takes a new build as soon as it sees one.
startVersionWatch({
  currentBuildId: __APP_BUILD_ID__,
  kiosk: window.location.pathname.startsWith('/p/'),
})

// A deploy replaces every hashed chunk, so a tab opened before it 404s on the
// first lazy route it hasn't loaded yet. Reload onto the new build instead,
// at most once per short window so a genuinely missing chunk can't loop.
const PRELOAD_RELOAD_KEY = 'polf-preload-reload-at'
window.addEventListener('vite:preloadError', (event) => {
  let last = 0
  try {
    last = Number(sessionStorage.getItem(PRELOAD_RELOAD_KEY) ?? 0)
    sessionStorage.setItem(PRELOAD_RELOAD_KEY, String(Date.now()))
  } catch {
    return
  }
  if (Date.now() - last < 10_000) return
  event.preventDefault()
  window.location.reload()
})

const root = document.getElementById('root')
if (!root) throw new Error('#root not found')

createRoot(root).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>
)
